import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, ManyToMany, OneToMany } from 'typeorm';
import { GenPartial, booleanTransformer, momentTransformer } from 'typeormgen';
import EpisodicBase from '../episodic-base.entity';
import MoneyTrackingPaymentPicture from '../money-tracking-payment-pictures/money-tracking-payment-picture.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';

@Entity('money_tracking_payments')
export default class MoneyTrackingPayment extends EpisodicBase {
	@Column('int')
	prod_id: number;

	@Column('int')
	money_tracking_group_id: number;

	@Column('int')
	money_tracking_vendor_id: number;

	@Column('varchar')
	vendor: string;

	@Column('varchar')
	name: string;

	@Column('int')
	type: number;

	@Column('int')
	line_number: number;

	@Column({ type: 'date', transformer: momentTransformer })
	date: Moment;

	@Column('int')
	purchase_type: number;

	@Column('varchar')
	style: string;

	@Column('varchar')
	brand: string;

	@Column('varchar')
	size: string;

	@Column('int')
	quantity: number;

	@Column('varchar')
	description: string;

	@Column('decimal')
	cost: string;

	@Column('decimal')
	tax: string;

	@Column('decimal')
	shipping: string;

	@Column({ type: 'tinyint', transformer: booleanTransformer })
	asset: boolean;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@ManyToMany(
		() => EpisodicItem,
		(episodicItem) => episodicItem.moneyTrackingPayments
	)
	episodicItems: EpisodicItem[];

	@OneToMany(
		() => MoneyTrackingPaymentPicture,
		(moneyTrackingPaymentPictures) =>
			moneyTrackingPaymentPictures.moneyTrackingPayment
	)
	moneyTrackingPaymentPictures: MoneyTrackingPaymentPicture[];

	static rules() {
		return {
			...super.rules(),
			prod_id: Joi.number().integer(),
			money_tracking_group_id: Joi.number().integer(),
			money_tracking_vendor_id: Joi.number().integer().allow(null),
			vendor: Joi.string().max(255),
			name: Joi.string().max(255),
			type: Joi.number().integer(),
			line_number: Joi.number().integer().allow(null),
			date: Joi.date().allow(null),
			purchase_type: Joi.number().integer().allow(null),
			style: Joi.string().max(1000).allow(null),
			brand: Joi.string().max(1000).allow(null),
			size: Joi.string().max(300).allow(null),
			quantity: Joi.number().integer().allow(null),
			description: Joi.string().max(255).allow(null),
			cost: Joi.string().max(11).allow(null),
			tax: Joi.string().max(11).allow(null),
			shipping: Joi.string().max(11).allow(null),
			asset: Joi.boolean(),
			last_updated_time: Joi.date().allow(null),
			date_created: Joi.date().allow(null),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			prod_id: this.prod_id,
			money_tracking_group_id: this.money_tracking_group_id,
			money_tracking_vendor_id: this.money_tracking_vendor_id,
			vendor: this.vendor,
			name: this.name,
			type: this.type,
			line_number: this.line_number,
			date: this.date,
			purchase_type: this.purchase_type,
			style: this.style,
			brand: this.brand,
			size: this.size,
			quantity: this.quantity,
			description: this.description,
			cost: this.cost,
			tax: this.tax,
			shipping: this.shipping,
			asset: this.asset,
			last_updated_time: this.last_updated_time,
			date_created: this.date_created,
		};
	}

	assign(props?: GenPartial<MoneyTrackingPayment>) {
		super.assign(props);

		if (props) {
			if (typeof props.date !== 'undefined') {
				this.date = momentTransformer.from(props.date);
			}
			if (typeof props.asset !== 'undefined') {
				this.asset = booleanTransformer.from(props.asset);
			}
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<MoneyTrackingPayment>) {
		super(props);
	}
}
